// lead-tracker.client.ts — collecte first-party de l'acquisition sur le SITE
// PUBLIC. Toute la logique vit dans @donoor/utils (`startLeadTracker`), partagée
// avec dashboard.donoor.org : deux copies auraient dérivé.
//
// Cf. docs/operations/lead-tracking-feature-plan.md et l'en-tête du module
// partagé pour le détail RGPD (tracking anonyme, aucune PII) et perf.

import { startLeadTracker } from "@donoor/utils";

export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  const apiBase = (config.public.apiBaseUrl as string) || "https://api.donoor.org";

  // Aligné sur les autres trackers : prod donoor.org ou dev local explicite.
  // (Les previews Vercel sont exclus pour ne pas polluer les stats.)
  const hostname = window.location.hostname;
  const isProdHost = hostname === "donoor.org" || hostname === "www.donoor.org";
  if (!isProdHost && !import.meta.dev) return;

  const router = useRouter();

  const track = startLeadTracker({
    apiBase,
    site: "public",
    onRouteChange: (cb) => router.afterEach(() => cb()),
    getPosthogSessionId: () => {
      try {
        const ph = (nuxtApp as { $posthog?: { __loaded?: boolean; get_session_id?: () => string } })
          .$posthog;
        if (ph?.__loaded && typeof ph.get_session_id === "function") return ph.get_session_id();
      } catch {
        /* ignore */
      }
      return undefined;
    },
  });

  // Exposé pour tracking manuel d'events métier (cta_click, signup_start, etc.)
  nuxtApp.provide("leadTrack", track);
});
